import { render, staticRenderFns } from "./trainingsHub.vue?vue&type=template&id=30e168ae&scoped=true"
import script from "./trainingsHub.vue?vue&type=script&lang=js"
export * from "./trainingsHub.vue?vue&type=script&lang=js"
import style0 from "./trainingsHub.vue?vue&type=style&index=0&id=30e168ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e168ae",
  null
  
)

export default component.exports